import { useState } from 'react'

import MuiButton from '@mui/material/Button'
import MuiMenu from '@mui/material/Menu'
import MuiListItemButton from '@mui/material/ListItemButton'
import MuiListItemText from '@mui/material/ListItemText'

import CampaignIcon from '@mui/icons-material/Campaign'

import RemoveFromCampaign from './removeFromCampaign'

const UnassignmentToolbar = ({ selectedIds, campaigns }) => {
  const [unassignAnchorEl, setUnassignAnchorEl] = useState(null)
  const unassignMenuOpen = Boolean(unassignAnchorEl)
  const [removeDialogOpen, setRemoveDialogOpen] = useState(false)
  const [selectedCampaignId, setSelectedCampaignId] = useState(null)

  const handleUnassignCampaignClick = (campaignId) => {
    setSelectedCampaignId(campaignId)
    setRemoveDialogOpen(true)
    handleUnassignClose()
  }

  const handleUnassignMenuClick = (event) => {
    setUnassignAnchorEl(event.currentTarget)
  }

  const handleUnassignClose = () => {
    setUnassignAnchorEl(null)
  }

  return (
    <>
      <MuiButton
        size="small"
        startIcon={<CampaignIcon />}
        onClick={handleUnassignMenuClick}
        disabled={!selectedIds.length}
      >
        Unassign
      </MuiButton>
      <MuiMenu
        id="campaignUnassignMenu"
        anchorEl={unassignAnchorEl}
        open={unassignMenuOpen}
        onClose={() => handleUnassignClose()}
      >
        {campaigns?.map((campaign) => [
          <MuiListItemButton key={campaign.id} onClick={() => handleUnassignCampaignClick(campaign.id)}>
            <MuiListItemText primary={campaign.name} />
          </MuiListItemButton>,
        ])}
      </MuiMenu>
      <RemoveFromCampaign
        open={removeDialogOpen}
        setOpen={setRemoveDialogOpen}
        prospectIds={selectedIds}
        campaignId={selectedCampaignId}
      />
    </>
  )
}

export default UnassignmentToolbar
